/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerOnlinePaymentRequest as ModelsCustomerCustomerOnlinePaymentRequest } from '../../models/Models/Customer/customer-online-payment-request';
import { CustomerOnlinePaymentResponse as ModelsCustomerCustomerOnlinePaymentResponse } from '../../models/Models/Customer/customer-online-payment-response';

export interface V3CustomersMeOnlinePaymentsPost$Json$Plain$Params {
      body?: ModelsCustomerCustomerOnlinePaymentRequest
}

export function v3CustomersMeOnlinePaymentsPost$Json$Plain(http: HttpClient, rootUrl: string, params?: V3CustomersMeOnlinePaymentsPost$Json$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentResponse>> {
  const rb = new RequestBuilder(rootUrl, v3CustomersMeOnlinePaymentsPost$Json$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentResponse>;
    })
  );
}

v3CustomersMeOnlinePaymentsPost$Json$Plain.PATH = '/v3/customers/me/online-payments';
